import * as React from "react";
import clsx from "clsx";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridCollapseContext } from "../grid-collapse-provider/grid-collapse-provider.mjs";
const GridCollapse = (props) => {
  const { children, className } = props;
  const { gridStyle, gridRef, setAnimated, initialColumnCount, isOpen, setActualColumnCount } = React.useContext(GridCollapseContext);
  React.useEffect(() => {
    if (setActualColumnCount) {
      setActualColumnCount(Array.isArray(children) ? children.length : 0);
    }
  }, [children, setActualColumnCount]);
  const onTransitionEnd = (event) => {
    if (gridRef && event.target === gridRef.current && event.propertyName === "height") {
      if (setAnimated) {
        setAnimated();
      }
    }
  };
  const getInitialColumns = () => {
    if (Array.isArray(children) && children.length > initialColumnCount) {
      return children.slice(0, initialColumnCount);
    }
    return initialColumnCount > 0 ? children : null;
  };
  return /* @__PURE__ */ React.createElement(Grid, { ...props, className: clsx("grid-collapse", className), gridRef, style: gridStyle, onTransitionEnd }, isOpen ? children : getInitialColumns());
};
export {
  GridCollapse
};
